export default "__VITE_ASSET__ca408af9__"